import { render, staticRenderFns } from "./FieldProperties.vue?vue&type=template&id=a170c1ba&scoped=true&"
import script from "./FieldProperties.vue?vue&type=script&lang=js&"
export * from "./FieldProperties.vue?vue&type=script&lang=js&"
import style0 from "./FieldProperties.vue?vue&type=style&index=0&id=a170c1ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a170c1ba",
  null
  
)

export default component.exports